<div #collapsible class="collapse" [id]="collapseId">
    <div class="card card-body">
        <div class="row">
            <div class="col-11">
                <div *ngIf="entry.description" class="row entry-row">
                    <div id="entry-description" class="col-12" [innerHTML]="entry.description"></div>
                </div>
                <div *ngIf="displayOverview" class="row entry-row">
                    <div id="entry-overview" class="col-12" [innerHTML]="displayOverview"></div>
                </div>
                <div *ngIf="entry.ticker" class="row entry-row">
                    <div class="col-3">{{'company_ticker' | i18next}}</div>
                    <div class="col-9">
                        <div>{{entry.ticker}}</div>
                    </div>
                </div>
               <div *ngIf="entry.naics" class="row entry-row">
                    <div class="col-3">{{'company_naics' | i18next}}</div>
                    <div class="col-9 use-for-term">
                        <div *ngFor="let prop of entry.naics; index as i">
                            <div>{{prop.name}}</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="entry.companyType" class="row entry-row">
                    <div class="col-3">{{'company_companyType' | i18next}}</div>
                    <div class="col-9">
                        <div>{{entry.companyType}}</div>
                    </div>
                </div>
               <div *ngIf="entry.useTermFor" class="row entry-row">
                    <div class="col-3">{{'useForTerm' | i18next}}</div>
                    <div class="col-9 use-for-term">
                        <div *ngFor="let prop of entry.useTermFor; index as i">
                            <div>{{prop.name}}</div>
                        </div>
                    </div>
                </div>
                 <div *ngIf="entry.registry" class="row entry-row">
                    <div class="col-3">{{'registryNumber' | i18next}}</div>
                    <div class="col-9">
                        <div>{{entry.registry}}</div>
                    </div>
                </div>
                <div *ngIf="entry.creationYear" class="row entry-row">
                    <div class="col-3">{{'creationYear' | i18next}}</div>
                    <div class="col-9">
                        <div>{{entry.creationYear}}</div>
                    </div>
                </div>
                <div *ngIf="entry.historyNote" class="row entry-row">
                    <div class="col-3">{{'historyNote' | i18next}}</div>
                    <div class="col-9">
                        <div>{{entry.historyNote}}</div>
                    </div>
                </div>
                <div *ngIf="entry.relatedTerms" class="row entry-row">
                    <div class="col-3">{{'relatedTerms' | i18next}}</div>
                    <div class="col-9">
                        <div *ngFor="let term of entry.relatedTerms; index as i" >
                            <input type="checkbox" name="term{{i}}" id="term{{i}}" value="{{term.name}}" (click)="onRelatedCheckboxChange(term.name, $event)" [checked]="termsService.isRelatedChecked(term.name) || termsService.isChecked(term.name)">
                            <a id="term-{{term.id}}" role="button" (click)="onEntryClick(term.termOrdinal)" class="collapsing-related-term">
                                <label for="term{{i}}">{{term.name}}</label>
                            </a>
                        </div>
                    </div>  
                </div>
                <div class="relatedTerms">
                    <div *ngIf="entry.broaderTerms && showBroaderTerms()" class="row entry-row" id="broaderTerms">
                        <h4>{{'broaderTerms' | i18next}}</h4>
                        <div class="col-9">
                            <div *ngFor="let term of entry.broaderTerms; index as i" class="relatedTerms">
                                <input type="checkbox" name="term{{i}}" id="term{{i}}" value="{{term.name}}" (click)="onRelatedCheckboxChange(term.name, $event)" [checked]="termsService.isRelatedChecked(term.name) || termsService.isChecked(term.name)">
                                <a id="term-{{term.id}}" role="button" (click)="onEntryClick(term.termOrdinal)" class="collapsing-related-term">
                                    <label for="term{{i}}">{{term.name}}</label>
                                </a>
                            </div>
                        </div>  
                    </div>
                    <div *ngIf="entry.narrowerTerms && showNarrowerTerms()" class="row entry-row" id="narrowerTerms">
                        <h4>{{'narrowerTerms' | i18next}}</h4>
                        <div class="col-9">
                            <div *ngFor="let term of entry.narrowerTerms; index as i" class="relatedTerms">
                                <input type="checkbox" name="term{{i}}" id="term{{i}}" value="{{term.name}}" (click)="onRelatedCheckboxChange(term.name, $event)" [checked]="termsService.isRelatedChecked(term.name) || termsService.isChecked(term.name)">
                                <a id="term-{{term.id}}" role="button" (click)="onEntryClick(term.termOrdinal)" class="collapsing-related-term">
                                    <label for="term{{i}}">{{term.name}}</label>
                                </a>
                            </div>
                        </div>  
                    </div>
                </div>

            </div>
        
            <div class="col-1 collapse-close-btn-wrapper">
                <div class="collapse-close-btn" role="button" aria-label="Close term" tabindex="0" (click)="closeBtn(collapseId);" (keydown.enter)="closeBtn(collapseId)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16" focusable="false" aria-hidden="true">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" role="presentation"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</div>
